import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: any
  /** An RFC 3986 and RFC 3987 compliant URI string. */
  URL: any
}

/** Represents information about personal information. */
export type Address = {
  __typename?: 'Address'
  /** The first line of the address. Typically the street address or PO Box number. */
  address1: Scalars['String']
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  address2?: Maybe<Scalars['String']>
  /** The name of the city, district, village, or town. */
  city: Scalars['String']
  /** The name of the country. */
  country?: Maybe<Scalars['String']>
  /** The three-letter code for the country of the address. For example, JPN. */
  countryCode?: Maybe<CountryCode>
  /** The region of the address, such as the province, state, prefecture, or district. */
  prefecture?: Maybe<Scalars['String']>
  /** The two-letter code for the region. For example, HK. */
  prefectureCode?: Maybe<PrefectureCode>
  /** The zip or postal code of the address. */
  zip: Scalars['String']
}

/** 適用されているディスカウントリスト */
export type AppliedDiscount = {
  __typename?: 'AppliedDiscount'
  discounts?: Maybe<DiscountConnection>
}

/** 適用されているディスカウントリスト */
export type AppliedDiscountDiscountsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  canOverlap?: InputMaybe<Scalars['Boolean']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  customerSelection?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  product?: InputMaybe<Scalars['ID']>
  status?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  usageLimit?: InputMaybe<Scalars['Int']>
}

/**
 * SAGAアリーナのみバリエーション毎に日付とQuantityを管理する必要があるため、
 * 予約作成時に入力されたバリエーション毎の利用日とQuantityを管理する。
 *
 * 例) SAGAアリーナのでは以下のようにOrderLineItemを管理する必要がある
 * 予約日時:
 * 1/1 ~ 1/3
 *
 * 予約対象:
 * - メインアリーナ 設営・撤去
 *     - Quantity: 3
 *     - dateOfUse: 1/1
 * - メインアリーナ 催事
 *     - Quantity: 1
 *     - dateOfUse: 1/2
 * - メインアリーナ 設営・撤去
 *     - Quantity: 4
 *     - dateOfUse: 1/3
 */
export type ArenaBookingInfo = Node & {
  __typename?: 'ArenaBookingInfo'
  /** 予約したバリエーションを実際に使用する日付 */
  dateOfUse: Scalars['Date']
  /** The ID of the object. */
  id: Scalars['ID']
  /** 予約時間 */
  quantity: Scalars['Int']
}

/** Represents a list of reservation dates and their data. */
export type BookingDate = Node & {
  __typename?: 'BookingDate'
  /** Time of check-in. */
  checkedInAt?: Maybe<Scalars['Time']>
  /** Time of check-out. */
  checkedOutAt?: Maybe<Scalars['Time']>
  /** Start date for a particular element. */
  date: Scalars['Date']
  /** Time that exceeded. */
  exceededTime?: Maybe<Scalars['Time']>
  /** The ID of the object. */
  id: Scalars['ID']
}

/** Simple booking status confirmation list. */
export type BookingStatusOfTheDay = {
  __typename?: 'BookingStatusOfTheDay'
  /** The Date data. */
  date?: Maybe<Scalars['Date']>
  /** The product's information. */
  products?: Maybe<Array<BookingStatusOfTheDayProducts>>
}

/** Arguments for calling BookingStatusOfTheDay. */
export type BookingStatusOfTheDayInput = {
  /** The Date data. */
  date?: InputMaybe<Scalars['Date']>
}

/** Variants information for product. */
export type BookingStatusOfTheDayProductVariants = {
  __typename?: 'BookingStatusOfTheDayProductVariants'
  /** The product's variant available for sale. */
  availableForSale: Scalars['Boolean']
  /** The reservation status from 9:00 to 21:00 is represented by '' and '[order id]', '' is a blank and [order id] is a have check mark (✔). */
  bookings: Array<Scalars['ID']>
  /** This object's id. */
  id: Scalars['ID']
  /** The product's variant name. */
  name: Scalars['String']
}

/** The product's information. */
export type BookingStatusOfTheDayProducts = {
  __typename?: 'BookingStatusOfTheDayProducts'
  /** This product's id. */
  id: Scalars['ID']
  /** The product's name. */
  name: Scalars['String']
  /** The product's variant. */
  variants?: Maybe<Array<BookingStatusOfTheDayProductVariants>>
}

/** Simple booking status confirmation month list. */
export type BookingStatusOfTheMonth = {
  __typename?: 'BookingStatusOfTheMonth'
  /** The Date data. */
  date?: Maybe<Scalars['Date']>
  /** The product's information. */
  products?: Maybe<Array<BookingStatusOfTheMonthProducts>>
}

/** Variants information for product. */
export type BookingStatusOfTheMonthProductVariants = {
  __typename?: 'BookingStatusOfTheMonthProductVariants'
  /** The product's variant available for sale. */
  availableForSale: Scalars['Boolean']
  /** List of Booking dates in variant for given month */
  bookingDates: Array<Maybe<Scalars['Date']>>
  /** This object's id. */
  id: Scalars['ID']
  /** The product's variant name. */
  name: Scalars['String']
}

/** The product's information. */
export type BookingStatusOfTheMonthProducts = {
  __typename?: 'BookingStatusOfTheMonthProducts'
  /** This product's id. */
  id: Scalars['ID']
  /** The product's name. */
  name: Scalars['String']
  /** The product's variant. */
  variants?: Maybe<Array<BookingStatusOfTheMonthProductVariants>>
}

/** Information about the order calendar. */
export type Calendar = {
  __typename?: 'Calendar'
  /** Whether the user agrees to have their order published online. */
  approval: Scalars['Boolean']
  /**
   * Name of the event.
   * (eventName)
   */
  eventName?: Maybe<Scalars['String']>
  /** Organizer of the event. */
  organizer?: Maybe<Scalars['String']>
  /**
   * Date the user wishes the order to be published.
   * (publishableDate)
   */
  publishableDate?: Maybe<Scalars['DateTime']>
}

/**
 * The three-letter code for the country of the address.
 *     For example, JPN.
 */
export enum CountryCode {
  /** Japan */
  Jpn = 'JPN',
}

/** Represents information about customers such as personal information. */
export type Customer = Node & {
  __typename?: 'Customer'
  /** Represents information about personal information. */
  address?: Maybe<Address>
  appliedDiscount?: Maybe<AppliedDiscount>
  /**
   * The account ID generated by Auth0.
   * (auth0Id)
   */
  auth0Id?: Maybe<Scalars['String']>
  /**
   * 新規登録後に審査され、予約可能な顧客が判別するためのフラグ
   * (bookableFlag)
   */
  bookableFlag: Scalars['Boolean']
  /**
   * The customer corporation's name.
   * (corporationName)
   */
  corporationName?: Maybe<Scalars['String']>
  /**
   * The customer corporation's name kana.
   * (corporationNameKana)
   */
  corporationNameKana?: Maybe<Scalars['String']>
  /**
   * Date and time when the customer was created.
   * (createdAt)
   */
  createdAt: Scalars['DateTime']
  /** The customer's email address. */
  email?: Maybe<Scalars['String']>
  /**
   * The customer's first name.
   * (firstName)
   */
  firstName: Scalars['String']
  /** The customer's full name. */
  fullname?: Maybe<Scalars['String']>
  /** The ID of the object. */
  id: Scalars['ID']
  /**
   * Whether the customer is active.
   * (isActive)
   */
  isActive: Scalars['Boolean']
  /**
   * The customer's last name.
   * (lastName)
   */
  lastName: Scalars['String']
  /** 顧客メタ情報 */
  metaFields?: Maybe<MetaFieldConnection>
  /** The customer's remarks. */
  note?: Maybe<Scalars['String']>
  /** The customer's phone number. */
  phone?: Maybe<Scalars['String']>
  /** The customer's tag list */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>
  /** The customer's type. */
  type: CustomerType
  /**
   * Date and time when the customer was last modified.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']
  /** Indicates information related to incidental information. */
  userMetaData?: Maybe<UserMetaData>
}

/** Represents information about customers such as personal information. */
export type CustomerMetaFieldsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  id?: InputMaybe<Scalars['ID']>
  key?: InputMaybe<Scalars['String']>
  last?: InputMaybe<Scalars['Int']>
  nameSpace?: InputMaybe<Scalars['String']>
  value?: InputMaybe<Scalars['Boolean']>
  valueType?: InputMaybe<Scalars['String']>
}

/** The customer condition type */
export enum CustomerConditionType {
  /** 部分一致 */
  Contains = 'CONTAINS',
  /** 後方一致 */
  Endswith = 'ENDSWITH',
  /** ＝ */
  Equal = 'EQUAL',
  /** 前方一致 */
  Startswith = 'STARTSWITH',
}

/** Specifies the query with the filtering information. */
export type CustomerQueryInput = {
  /** Specify the search conditions. (startswith / contains / endswith / equal) If no value or another value will be "equal". */
  condition?: InputMaybe<CustomerConditionType>
  /** Specify the customer field to query. */
  field: Scalars['String']
  /** Specify the search type of query.(AND / OR)This parameter is used when connecting to a previous query, and ignored the first time. If no value or another value will be "OR". */
  type?: InputMaybe<CustomerQueryType>
  /** Specify the search keyword. */
  value: Scalars['String']
}

/** The customer query type */
export enum CustomerQueryType {
  /** AND */
  And = 'AND',
  /** OR */
  Or = 'OR',
}

/** The customer type */
export enum CustomerType {
  /** 法人 */
  Corporate = 'CORPORATE',
  /** 個人 */
  Personal = 'PERSONAL',
  /** 顧客タイプ未登録 */
  Unregistered = 'UNREGISTERED',
}

/** ディスカウントオブジェクト */
export type Discount = Node & {
  __typename?: 'Discount'
  /**
   * 他のディスカウントとの重複可否
   * (canOverlap)
   */
  canOverlap?: Maybe<Scalars['Boolean']>
  /**
   * 作成日時
   * (createdAt)
   */
  createdAt: Scalars['DateTime']
  /**
   * ディスカウントを使用可能なカスタマー
   * (customerSelection)
   */
  customerSelection?: Maybe<Array<Maybe<Scalars['String']>>>
  /** 説明 */
  description?: Maybe<Scalars['String']>
  /** 割引率 */
  discountPercent?: Maybe<DiscountPercent>
  /** The ID of the object. */
  id: Scalars['ID']
  /** Information about the product. */
  product?: Maybe<Product>
  /** The payment status. */
  status: Scalars['String']
  /** タイトル */
  title: Scalars['String']
  /**
   * 更新日時
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']
  /**
   * 毎月の最大使用可能回数
   * (usageLimit)
   */
  usageLimit: Scalars['Int']
}

export type DiscountConnection = {
  __typename?: 'DiscountConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DiscountEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']
}

/** A Relay edge containing a `Discount` and its cursor. */
export type DiscountEdge = {
  __typename?: 'DiscountEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node?: Maybe<Discount>
}

/** 手入力割引の情報 */
export type DiscountFee = {
  __typename?: 'DiscountFee'
  /** Reason for discount fee. */
  reason: Scalars['String']
  /** The discount amount. */
  value: Scalars['Float']
}

export type DiscountPercent = {
  __typename?: 'DiscountPercent'
  /** 割引率の分母 */
  denominator: Scalars['Int']
  /** 割引率のラベル */
  discountPercentLabel: DiscountPercentLabel
  /** 割引率の分子 */
  numerator: Scalars['Int']
}

/** The discount percent. */
export enum DiscountPercentLabel {
  /** 全額減免 */
  Full = 'FULL',
  /** 1/2減免 */
  OneHalf = 'ONE_HALF',
  /** 2/3減免 */
  TwoThird = 'TWO_THIRD',
}

/** Information about the order extension fee. */
export type ExtensionFee = Node & {
  __typename?: 'ExtensionFee'
  /** The ID of the object. */
  id: Scalars['ID']
  /** Reason for exceed fee. */
  reason: Scalars['String']
  /** The excess amount. */
  value: Scalars['Float']
}

/** Represents a multilingual character string. */
export type I18nString = {
  __typename?: 'I18nString'
  /** The english string value. */
  enUs?: Maybe<Scalars['String']>
  /** The japanese string value. */
  jaJp: Scalars['String']
  /** The korean string value. */
  koKr?: Maybe<Scalars['String']>
  /** The chinese string value. */
  zhCn?: Maybe<Scalars['String']>
  /** The taiwan string value. */
  zhTw?: Maybe<Scalars['String']>
}

/** Represents an image resource. */
export type Image = Node & {
  __typename?: 'Image'
  Cls?: Maybe<Scalars['String']>
  /**
   * A word or phrase to share the nature or contents of an file.
   * (altText)
   */
  altText?: Maybe<Scalars['String']>
  /** The file encoding. */
  encoding?: Maybe<Scalars['String']>
  /** The human friendly file name. */
  filename: Scalars['String']
  /** The file path. */
  filepath?: Maybe<Scalars['String']>
  /** The ID of the object. */
  id: Scalars['ID']
  /** The unique actual file name on storage. */
  key: Scalars['String']
  /**
   * The mime type of uploaded file
   * (mimeType)
   */
  mimeType: Scalars['String']
  /** The size of file. */
  size?: Maybe<Scalars['Int']>
  /** The location of the image as a URL. */
  src: Scalars['URL']
}

/** クリッカブルマップの座標 */
export type MapPosition = Node & {
  __typename?: 'MapPosition'
  /** The ID of the object. */
  id: Scalars['ID']
  /** 緯度 */
  lat: Scalars['Int']
  /** 経度 */
  lng: Scalars['Int']
}

/** Represents object for the member model. */
export type Member = Node & {
  __typename?: 'Member'
  /**
   * The account ID generated by Auth0.
   * (auth0Id)
   */
  auth0Id?: Maybe<Scalars['String']>
  /**
   * The member's avatar image URL.
   * (avatarUrl)
   */
  avatarUrl?: Maybe<Scalars['String']>
  /**
   * Date and time when the member was created.
   * (createdAt)
   */
  createdAt: Scalars['DateTime']
  /** The member's email address. */
  email: Scalars['String']
  /**
   * The member's first name.
   * (firstName)
   */
  firstName: Scalars['String']
  /** The ID of the object. */
  id: Scalars['ID']
  /**
   * Whether the member has verified their email address.
   * (isActive)
   */
  isActive: Scalars['Boolean']
  /**
   * The member's last name.
   * (lastName)
   */
  lastName: Scalars['String']
  /**
   * Date and time when the member was last modified.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']
}

/** 顧客メタ情報 */
export type MetaField = Node & {
  __typename?: 'MetaField'
  /** The ID of the object. */
  id: Scalars['ID']
  key: Scalars['String']
  nameSpace: Scalars['String']
  value: Scalars['Boolean']
  valueType: Scalars['String']
}

export type MetaFieldConnection = {
  __typename?: 'MetaFieldConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetaFieldEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']
}

/** A Relay edge containing a `MetaField` and its cursor. */
export type MetaFieldEdge = {
  __typename?: 'MetaFieldEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node?: Maybe<MetaField>
}

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID']
}

/** Represents information about the order such as the reservation date and time and the products to be reserved. */
export type Order = Node & {
  __typename?: 'Order'
  /** The approval status of the order. */
  approval: OrderApproval
  /**
   * Whether the reservation requires approval.
   * (approvalRequired)
   */
  approvalRequired: Scalars['Boolean']
  /** Time zone booked by order. */
  bookingDates: Array<BookingDate>
  /** Calendar information. */
  calendar?: Maybe<Calendar>
  /** The reasons to cancel your booking. */
  cancelReason?: Maybe<OrderCancelReason>
  /** The date and time when the booking was canceled. */
  canceledAt?: Maybe<Scalars['DateTime']>
  /** The cost of cancelled reservations. */
  cancellationFee?: Maybe<Scalars['Float']>
  /** Information about the customer representing the group. */
  contactOfRepresentative?: Maybe<Representative>
  /**
   * The date and time the order was created.
   * (createdAt)
   */
  createdAt: Scalars['DateTime']
  /** Information about the customer. */
  customer?: Maybe<Customer>
  /**
   * ディスカウントコレクション
   * ID of the discount what applied the order.
   * (discountId)
   */
  discount?: Maybe<Discount>
  /** 手入力で割引を適用した際の情報 */
  discountFee?: Maybe<DiscountFee>
  /**
   * The discount price.
   * (discountPrice)
   */
  discountPrice?: Maybe<Scalars['Float']>
  /**
   * Whether the customer will be charged for entry.
   * (entryFee)
   */
  entryFee: Scalars['Boolean']
  /** Estimate number linked to the order." */
  estimateNumber?: Maybe<Scalars['String']>
  /** Information about the extension fee. */
  extensionFee?: Maybe<Array<Maybe<ExtensionFee>>>
  /** The ID of the object. */
  id: Scalars['ID']
  /** List of the order's line items. */
  lineItems?: Maybe<OrderLineItemConnection>
  modifierInfo?: Maybe<OrderModifierConnection>
  /**
   * The number of customers in the group.
   * (numberOfPeople)
   */
  numberOfPeople: Scalars['Int']
  /**
   * The user-identifiable order number.
   * (orderNumber)
   */
  orderNumber: Scalars['Int']
  /**
   * 施設利用料 小計(税込)
   * (originalSubTotalPrice)
   */
  originalSubTotalPrice: Scalars['Float']
  /**
   * 施設利用料 小計(税抜)
   * (originalSubTotalPriceTaxExcluded)
   */
  originalSubTotalPriceTaxExcluded: Scalars['Float']
  /**
   * The total amount including tax at the time of booking.
   * (originalTotalPrice)
   */
  originalTotalPrice: Scalars['Float']
  /**
   * The tax amount at the time of booking.
   * (originalTotalTax)
   */
  originalTotalTax: Scalars['Float']
  /** Payment information. */
  payment?: Maybe<Payment>
  /** Time zone booked by order. */
  period?: Maybe<Period>
  /** Purpose of reservation. */
  purpose?: Maybe<OrderPurpose>
  /** Rate information. */
  rate?: Maybe<RateInfo>
  /**
   * The reason for disapproval of reservation.
   * (reasonForDisapproval)
   */
  reasonForDisapproval?: Maybe<Scalars['String']>
  /**
   * Receipt number linked to the order.
   * (receiptNumber)
   */
  receiptNumber?: Maybe<Scalars['String']>
  /** Refund information. */
  refund?: Maybe<Refund>
  /** 領収証が再発行された場合のフラグ。再発行された場合はTrueになる。 */
  reissue?: Maybe<Scalars['Boolean']>
  /**
   * Whether the customer will be selling goods.
   * (saleOfGoods)
   */
  saleOfGoods: Scalars['Boolean']
  /**
   * The user-identifiable serial number.
   * (serialNumber)
   */
  serialNumber: Scalars['String']
  /**
   * Whether or not the calculated price includes special price.
   * (specialPriceIncluded)
   */
  specialPriceIncluded: Scalars['Boolean']
  /** The order status */
  status: OrderStatus
  /**
   * 予約された施設のドメイン名(例:saga-arena)
   * (storeDomain)
   */
  storeDomain?: Maybe<Scalars['String']>
  /**
   * 小計(税込)
   * (subTotalPrice)
   */
  subTotalPrice: Scalars['Float']
  /**
   * 小計(税抜)
   * (subTotalPriceTaxExcluded)
   */
  subTotalPriceTaxExcluded: Scalars['Float']
  /**
   * The total amount including tax at the time of settlement.
   * (totalPrice)
   */
  totalPrice: Scalars['Float']
  /**
   * The total tax amount at the time of settlement.
   * (totalTax)
   */
  totalTax: Scalars['Float']
  /**
   * The date and time the order was updated.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']
}

/** Represents information about the order such as the reservation date and time and the products to be reserved. */
export type OrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>
  baseTimeUnit?: InputMaybe<Scalars['Int']>
  before?: InputMaybe<Scalars['String']>
  colorCode?: InputMaybe<Scalars['String']>
  displayCalendar?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  price?: InputMaybe<Scalars['Float']>
  product?: InputMaybe<Scalars['ID']>
  quantity?: InputMaybe<Scalars['Int']>
  specialPrice?: InputMaybe<Scalars['Float']>
  timeBased?: InputMaybe<Scalars['Boolean']>
  unit?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<Scalars['ID']>
}

/** Represents information about the order such as the reservation date and time and the products to be reserved. */
export type OrderModifierInfoArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  modifiedAt?: InputMaybe<Scalars['DateTime']>
  modifier?: InputMaybe<Scalars['ID']>
  reason?: InputMaybe<Scalars['String']>
}

/** The Order status type */
export enum OrderApproval {
  /** 承認 */
  Approved = 'APPROVED',
  /** 非承認 */
  Disapproved = 'DISAPPROVED',
  /** 承認待ち */
  Pending = 'PENDING',
}

/** The Order Cancel Code */
export enum OrderCancelReason {
  /** The customer wanted to cancel the order. */
  Customer = 'CUSTOMER',
  /** Payment was declined. */
  Declined = 'DECLINED',
  /** The order was fraudulent. */
  Fraud = 'FRAUD',
  /** There was insufficient inventory. */
  Inventory = 'INVENTORY',
  /** Some other reason not listed. */
  Other = 'OTHER',
}

export type OrderConnection = {
  __typename?: 'OrderConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']
}

/** A Relay edge containing a `Order` and its cursor. */
export type OrderEdge = {
  __typename?: 'OrderEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node?: Maybe<Order>
}

/** Represents a list of ordered products. */
export type OrderLineItem = Node & {
  __typename?: 'OrderLineItem'
  /** SAGAアリーナの予約情報 */
  arenaBookingInfo?: Maybe<Array<Maybe<ArenaBookingInfo>>>
  /**
   * Basic time unit for calculating the bill.
   * (baseTimeUnit)
   */
  baseTimeUnit?: Maybe<Scalars['Int']>
  /** レンダーに表示する際に使用するカラーコード */
  colorCode?: Maybe<Scalars['String']>
  /** カレンダーに表示するか */
  displayCalendar?: Maybe<Scalars['Boolean']>
  /** The ID of the object. */
  id: Scalars['ID']
  /** The product name. */
  name: I18nString
  /** The Price of the product to be reserved. */
  price: Scalars['Float']
  /** Information about the product. */
  product?: Maybe<Product>
  /** The number of variant items ordered. */
  quantity: Scalars['Int']
  /**
   * The price for weekends and holidays.
   * (specialPrice)
   */
  specialPrice: Scalars['Float']
  /**
   * Whether it is a variant that charges on an hourly basis.
   * (timeBased)
   */
  timeBased: Scalars['Boolean']
  /** The payment status. */
  unit?: Maybe<Scalars['String']>
  /** The product variation information. */
  variant?: Maybe<Scalars['ID']>
  /** Name of the variant. */
  variantTitle?: Maybe<I18nString>
}

export type OrderLineItemConnection = {
  __typename?: 'OrderLineItemConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderLineItemEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']
}

/** A Relay edge containing a `OrderLineItem` and its cursor. */
export type OrderLineItemEdge = {
  __typename?: 'OrderLineItemEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node?: Maybe<OrderLineItem>
}

/** Represents the member who modified the order. */
export type OrderModifier = Node & {
  __typename?: 'OrderModifier'
  /** The ID of the object. */
  id: Scalars['ID']
  /**
   * Date and time the order was modified by the member.
   * (modifiedAt)
   */
  modifiedAt: Scalars['DateTime']
  /** ID of the member who modified the order. */
  modifier?: Maybe<Member>
  /** Reason for modifying the order. */
  reason: Scalars['String']
}

export type OrderModifierConnection = {
  __typename?: 'OrderModifierConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderModifierEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']
}

/** A Relay edge containing a `OrderModifier` and its cursor. */
export type OrderModifierEdge = {
  __typename?: 'OrderModifierEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node?: Maybe<OrderModifier>
}

/** Purpose for booking. */
export enum OrderPurpose {
  /** ライブ・コンサート */
  Concert = 'CONCERT',
  /** イベント利用 */
  Event = 'EVENT',
  /** 一般利用 */
  General = 'GENERAL',
  /** その他 */
  Other = 'OTHER',
  /** スポーツ */
  Sport = 'SPORT',
}

/** The Order status */
export enum OrderStatus {
  /** 確定 */
  Confirmed = 'CONFIRMED',
  /** 下書き */
  Draft = 'DRAFT',
}

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>
}

/** Represents payment information for an order. */
export type Payment = {
  __typename?: 'Payment'
  /** The payment amount. */
  amount?: Maybe<Scalars['Float']>
  /**
   * The reason for a payment error.
   * (errorMessage)
   */
  errorMessage?: Maybe<Scalars['String']>
  /**
   * The date and time when payment was completed.
   * (processedAt)
   */
  processedAt?: Maybe<Scalars['DateTime']>
  /**
   * The refundable deadline.
   * (refundablePeriod)
   */
  refundablePeriod?: Maybe<Scalars['DateTime']>
  /** The payment status. */
  status: PaymentStatus
  /**
   * The date and time the payment information was updated.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']
}

/** The payment status */
export enum PaymentStatus {
  /** 支払い完了 */
  Complete = 'COMPLETE',
  /** 支払不備 */
  Failure = 'FAILURE',
  /** 支払い待ち */
  Wait = 'WAIT',
}

/** A collection that divides and holds the time zones that can be booked. */
export type Period = {
  __typename?: 'Period'
  /** End time. */
  end?: Maybe<Scalars['Time']>
  /** Start time. */
  start?: Maybe<Scalars['Time']>
}

/** Represents the period for sale information. */
export type PeriodForSale = Node & {
  __typename?: 'PeriodForSale'
  /** The date when the variant becomes unavailable for sale. */
  end?: Maybe<Scalars['Date']>
  /** The ID of the object. */
  id: Scalars['ID']
  /** The date when the variant becomes available for sale. */
  start?: Maybe<Scalars['Date']>
}

/** Prefecture codes with some differences. */
export enum PrefectureCode {
  /** 愛知県 */
  Ai = 'AI',
  /** 秋田県 */
  Ak = 'AK',
  /** 青森県 */
  Ao = 'AO',
  /** 千葉県 */
  Cb = 'CB',
  /** 愛媛県 */
  Eh = 'EH',
  /** 福井県 */
  Fi = 'FI',
  /** 福岡県 */
  Fo = 'FO',
  /** 福島県 */
  Fs = 'FS',
  /** 岐阜県 */
  Gi = 'GI',
  /** 群馬県 */
  Gu = 'GU',
  /** 兵庫県 */
  Hg = 'HG',
  /** 北海道 */
  Hk = 'HK',
  /** 広島県 */
  Hs = 'HS',
  /** 茨城県 */
  Ib = 'IB',
  /** 石川県 */
  Is = 'IS',
  /** 岩手県 */
  It = 'IT',
  /** 香川県 */
  Ka = 'KA',
  /** 鹿児島県 */
  Kg = 'KG',
  /** 神奈川県 */
  Kn = 'KN',
  /** 高知県 */
  Ko = 'KO',
  /** 熊本県 */
  Ku = 'KU',
  /** 京都府 */
  Ky = 'KY',
  /** 三重県 */
  Me = 'ME',
  /** 宮城県 */
  Mg = 'MG',
  /** 宮崎県 */
  Mz = 'MZ',
  /** 長野県 */
  Na = 'NA',
  /** 新潟県 */
  Ni = 'NI',
  /** 奈良県 */
  Nr = 'NR',
  /** 長崎県 */
  Ns = 'NS',
  /** 大分県 */
  Oi = 'OI',
  /** 沖縄県 */
  Ok = 'OK',
  /** 大阪府 */
  Os = 'OS',
  /** 岡山県 */
  Oy = 'OY',
  /** 佐賀県 */
  Sg = 'SG',
  /** 滋賀県 */
  Si = 'SI',
  /** 島根県 */
  Sn = 'SN',
  /** 埼玉県 */
  St = 'ST',
  /** 静岡県 */
  Sz = 'SZ',
  /** 栃木県 */
  Tc = 'TC',
  /** 徳島県 */
  Tk = 'TK',
  /** 富山県 */
  Tm = 'TM',
  /** 鳥取県 */
  Tt = 'TT',
  /** 東京都 */
  Ty = 'TY',
  /** 和歌山県 */
  Wa = 'WA',
  /** 山口県 */
  Ya = 'YA',
  /** 山形県 */
  Yg = 'YG',
  /** 山梨県 */
  Yn = 'YN',
}

/**
 * Represents information about product such as name and price.
 * It also includes the price and status of each product variation.
 */
export type Product = Node & {
  __typename?: 'Product'
  /**
   * True if only administrators can create reservations for this product.
   * (adminOnlyReservation)
   */
  adminOnlyReservation: Scalars['Boolean']
  /**
   * Whether the product requires approval.
   * (approvalRequired)
   */
  approvalRequired: Scalars['Boolean']
  /**
   * Basic time unit for calculating the bill.
   * (baseTimeUnit)
   */
  baseTimeUnit?: Maybe<Scalars['Int']>
  /**
   * The date and time the product was created.
   * (createdAt)
   */
  createdAt: Scalars['DateTime']
  /** Represents multilingual product description. */
  description?: Maybe<I18nString>
  /** Represents multilingual product description without HTML tags. */
  descriptionPlainText?: Maybe<Scalars['String']>
  /** The ID of the object. */
  id: Scalars['ID']
  /** The images associated with the product. */
  images?: Maybe<Array<Image>>
  /** The map image associated with the product. */
  mapImage?: Maybe<Image>
  /** クリッカブルマップの座標 */
  mapPosition?: Maybe<MapPosition>
  /** Represents multilingual product name. */
  name: I18nString
  /** Represents information about product option list. */
  options?: Maybe<Array<Maybe<ProductOption>>>
  /**
   * The date and time when the product was published Online.
   * (publishedAt)
   */
  publishedAt?: Maybe<Scalars['DateTime']>
  /** The product status. */
  status: ProductStatus
  /**
   * Whether to calculate charges on a 10-minute basis.
   * (timeBased)
   */
  timeBased: Scalars['Boolean']
  /**
   * The date and time the product was updated.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']
  /** Represents information about product variation list. */
  variants?: Maybe<ProductVariantConnection>
}

/**
 * Represents information about product such as name and price.
 * It also includes the price and status of each product variation.
 */
export type ProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>
  availableForSale?: InputMaybe<Scalars['Boolean']>
  before?: InputMaybe<Scalars['String']>
  colorCode?: InputMaybe<Scalars['String']>
  compareAtPrice?: InputMaybe<Scalars['Float']>
  displayCalendar?: InputMaybe<Scalars['Boolean']>
  excess?: InputMaybe<Scalars['Float']>
  first?: InputMaybe<Scalars['Int']>
  id?: InputMaybe<Scalars['ID']>
  inventory?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  percentageOfProduct?: InputMaybe<Scalars['Float']>
  position?: InputMaybe<Scalars['Int']>
  price?: InputMaybe<Scalars['Float']>
  relatedVariations?: InputMaybe<Scalars['String']>
  specialPrice?: InputMaybe<Scalars['Float']>
  unit?: InputMaybe<UnitCode>
}

/** Represents product option information. */
export type ProductOption = Node & {
  __typename?: 'ProductOption'
  /** The ID of the object. */
  id: Scalars['ID']
  /** Represents the name of a product option. */
  name?: Maybe<I18nString>
  /** The order of the product option in the list of product options. The first position in the list is 1. */
  position: Scalars['Int']
  /** Represents a list of product option values. */
  values?: Maybe<Array<Maybe<I18nString>>>
}

/** The product status */
export enum ProductStatus {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** ARCHIVED */
  Archived = 'ARCHIVED',
  /** DRAFT */
  Draft = 'DRAFT',
  /** INACTIVE */
  Inactive = 'INACTIVE',
}

/** Represents product variation information. */
export type ProductVariant = Node & {
  __typename?: 'ProductVariant'
  /**
   * Whether the product variant is available for sale.
   * (availableForSale)
   */
  availableForSale: Scalars['Boolean']
  /** レンダーに表示する際に使用するカラーコード */
  colorCode?: Maybe<Scalars['String']>
  /**
   * The compare-at price of the variant in the default shop currency.
   * (compareAtPrice)
   */
  compareAtPrice?: Maybe<Scalars['Float']>
  /** カレンダーに表示するか */
  displayCalendar?: Maybe<Scalars['Boolean']>
  /** Amount to be charged when the reserved time is exceeded. */
  excess?: Maybe<Scalars['Float']>
  /** The ID of the object. */
  id: Scalars['ID']
  /** The variant inventory. */
  inventory?: Maybe<Scalars['Int']>
  /**
   * 施設を分割して貸し出す場合は、予約時にこの数値を合計し予約可能か判定する。
   * (percentageOfProduct)
   */
  percentageOfProduct?: Maybe<Scalars['Float']>
  /**
   * 販売期間のコレクション
   * The period for when the variant is available.
   * (periodForSale)
   */
  periodForSale?: Maybe<PeriodForSale>
  /** The order of the product variant in the list of product variants. The first position in the list is 1. */
  position: Scalars['Int']
  /** The price of the product variant in the default shop currency. */
  price: Scalars['Float']
  /** 関連付けられたバリエーションのリスト。このリストに追加されているバリエーションが予約されている場合は、予約不可。 */
  relatedVariations?: Maybe<Array<Maybe<Scalars['String']>>>
  /** Represents a list of options selected in a variation. */
  selectedOptions?: Maybe<Array<Maybe<SelectedOption>>>
  /**
   * The price for weekends and holidays.
   * (specialPrice)
   */
  specialPrice: Scalars['Float']
  /** Represents the name of a product variation. */
  title: I18nString
  /** バリエーションの料金を計算する単位 */
  unit?: Maybe<UnitCode>
}

export type ProductVariantConnection = {
  __typename?: 'ProductVariantConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductVariantEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']
}

/** A Relay edge containing a `ProductVariant` and its cursor. */
export type ProductVariantEdge = {
  __typename?: 'ProductVariantEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node?: Maybe<ProductVariant>
}

export type QueryRoot = {
  __typename?: 'QueryRoot'
  /** Simple booking status confirmation list. */
  bookingStatusOfTheDay?: Maybe<BookingStatusOfTheDay>
  /** Simple booking status confirmation month list. */
  bookingStatusOfTheMonth?: Maybe<BookingStatusOfTheMonth>
  /** Get specific order information. */
  orderForObserver?: Maybe<Order>
  /** ストア内の全予約情報を取得する */
  orders?: Maybe<OrderConnection>
}

export type QueryRootBookingStatusOfTheDayArgs = {
  input?: InputMaybe<BookingStatusOfTheDayInput>
}

export type QueryRootBookingStatusOfTheMonthArgs = {
  date?: InputMaybe<Scalars['Date']>
}

export type QueryRootOrderForObserverArgs = {
  id: Scalars['ID']
  store?: InputMaybe<Scalars['String']>
}

export type QueryRootOrdersArgs = {
  after?: InputMaybe<Scalars['String']>
  approval?: InputMaybe<OrderApproval>
  approvalRequired?: InputMaybe<Scalars['Boolean']>
  before?: InputMaybe<Scalars['String']>
  bookingDates?: InputMaybe<Scalars['Date']>
  bookingDates_Gt?: InputMaybe<Scalars['Date']>
  bookingDates_Gte?: InputMaybe<Scalars['Date']>
  bookingDates_Lt?: InputMaybe<Scalars['Date']>
  bookingDates_Lte?: InputMaybe<Scalars['Date']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  createdAt_All?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>
  createdAt_In?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>
  createdAt_Nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
  customer?: InputMaybe<Scalars['ID']>
  customerQuery?: InputMaybe<Array<InputMaybe<CustomerQueryInput>>>
  discount?: InputMaybe<Scalars['ID']>
  discountPrice?: InputMaybe<Scalars['Float']>
  displayCalendar?: InputMaybe<Scalars['Boolean']>
  entryFee?: InputMaybe<Scalars['Boolean']>
  estimateNumber?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  numberOfPeople?: InputMaybe<Scalars['Int']>
  numberOfPeople_All?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>
  numberOfPeople_Gte?: InputMaybe<Scalars['Int']>
  numberOfPeople_Lte?: InputMaybe<Scalars['Int']>
  orderNumber?: InputMaybe<Scalars['Int']>
  orderNumber_Contains?: InputMaybe<Scalars['Int']>
  orderNumber_Endswith?: InputMaybe<Scalars['Int']>
  orderNumber_Regex?: InputMaybe<Scalars['Int']>
  orderNumber_Startswith?: InputMaybe<Scalars['Int']>
  originalSubTotalPrice?: InputMaybe<Scalars['Float']>
  originalSubTotalPriceTaxExcluded?: InputMaybe<Scalars['Float']>
  originalSubTotalPriceTaxExcluded_All?: InputMaybe<
    Array<InputMaybe<Scalars['Float']>>
  >
  originalSubTotalPriceTaxExcluded_Gte?: InputMaybe<Scalars['Float']>
  originalSubTotalPriceTaxExcluded_Lte?: InputMaybe<Scalars['Float']>
  originalSubTotalPrice_All?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
  originalSubTotalPrice_Gte?: InputMaybe<Scalars['Float']>
  originalSubTotalPrice_Lte?: InputMaybe<Scalars['Float']>
  originalTotalPrice?: InputMaybe<Scalars['Float']>
  originalTotalPrice_All?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
  originalTotalPrice_Gte?: InputMaybe<Scalars['Float']>
  originalTotalPrice_Lte?: InputMaybe<Scalars['Float']>
  originalTotalTax?: InputMaybe<Scalars['Float']>
  originalTotalTax_All?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
  originalTotalTax_Gte?: InputMaybe<Scalars['Float']>
  originalTotalTax_Lte?: InputMaybe<Scalars['Float']>
  productName?: InputMaybe<Scalars['String']>
  productName_Contains?: InputMaybe<Scalars['String']>
  productName_Endswith?: InputMaybe<Scalars['String']>
  productName_Startswith?: InputMaybe<Scalars['String']>
  purpose?: InputMaybe<OrderPurpose>
  reasonForDisapproval?: InputMaybe<Scalars['String']>
  reasonForDisapproval_Contains?: InputMaybe<Scalars['String']>
  reasonForDisapproval_Endswith?: InputMaybe<Scalars['String']>
  reasonForDisapproval_Regex?: InputMaybe<Scalars['String']>
  reasonForDisapproval_Startswith?: InputMaybe<Scalars['String']>
  receiptNumber?: InputMaybe<Scalars['String']>
  reissue?: InputMaybe<Scalars['Boolean']>
  saleOfGoods?: InputMaybe<Scalars['Boolean']>
  serialNumber?: InputMaybe<Scalars['String']>
  serialNumber_Contains?: InputMaybe<Scalars['String']>
  serialNumber_Endswith?: InputMaybe<Scalars['String']>
  serialNumber_Regex?: InputMaybe<Scalars['String']>
  serialNumber_Startswith?: InputMaybe<Scalars['String']>
  sort?: InputMaybe<SortInput>
  specialPriceIncluded?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<OrderStatus>
  storeDomain?: InputMaybe<Scalars['String']>
  subTotalPrice?: InputMaybe<Scalars['Float']>
  subTotalPriceTaxExcluded?: InputMaybe<Scalars['Float']>
  subTotalPriceTaxExcluded_All?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
  subTotalPriceTaxExcluded_Gte?: InputMaybe<Scalars['Float']>
  subTotalPriceTaxExcluded_Lte?: InputMaybe<Scalars['Float']>
  subTotalPrice_All?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
  subTotalPrice_Gte?: InputMaybe<Scalars['Float']>
  subTotalPrice_Lte?: InputMaybe<Scalars['Float']>
  totalPrice?: InputMaybe<Scalars['Float']>
  totalPrice_All?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
  totalPrice_Gte?: InputMaybe<Scalars['Float']>
  totalPrice_Lte?: InputMaybe<Scalars['Float']>
  totalTax?: InputMaybe<Scalars['Float']>
  totalTax_All?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
  totalTax_Gte?: InputMaybe<Scalars['Float']>
  totalTax_Lte?: InputMaybe<Scalars['Float']>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  updatedAt_All?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']>
  updatedAt_In?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']>
  updatedAt_Nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
}

/** Price list collection information */
export type Rate = Node & {
  __typename?: 'Rate'
  /**
   * The date and time the rate was created.
   * (createdAt)
   */
  createdAt: Scalars['DateTime']
  /** Represents multilingual rate description. */
  description?: Maybe<I18nString>
  /** Represents multilingual product description without HTML tags. */
  descriptionPlainText?: Maybe<Scalars['String']>
  /** The ID of the object. */
  id: Scalars['ID']
  /** The rate status. */
  status: RateStatus
  /** The title of the rate. */
  title: I18nString
  /**
   * The date and time the rate was updated.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']
  /** Represents information about rate variation list. */
  variants?: Maybe<RateVariantConnection>
}

/** Price list collection information */
export type RateVariantsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  id?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  position?: InputMaybe<Scalars['Int']>
  rate?: InputMaybe<Scalars['Float']>
}

/** Information about the order rate. */
export type RateInfo = {
  __typename?: 'RateInfo'
  /** The parent Rate object. */
  parent?: Maybe<Rate>
  /** The rate of the rate collection variant. */
  rate: Scalars['Float']
  /** The product variation title. */
  title?: Maybe<I18nString>
  /**
   * ID of the rate variant.
   * (variantId)
   */
  variantId: Scalars['ID']
}

/** The rate status */
export enum RateStatus {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** ARCHIVED */
  Archived = 'ARCHIVED',
  /** INACTIVE */
  Inactive = 'INACTIVE',
}

/** Represents rate variation information. */
export type RateVariant = Node & {
  __typename?: 'RateVariant'
  /** The ID of the object. */
  id: Scalars['ID']
  /** A collection that divides and holds the time zones that can be reserved. */
  period?: Maybe<Period>
  /** The position of the rate variant. */
  position?: Maybe<Scalars['Int']>
  /** The rate of the rate collection variant. */
  rate: Scalars['Float']
}

export type RateVariantConnection = {
  __typename?: 'RateVariantConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RateVariantEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']
}

/** A Relay edge containing a `RateVariant` and its cursor. */
export type RateVariantEdge = {
  __typename?: 'RateVariantEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node?: Maybe<RateVariant>
}

/** Represents refund information when a refund is made to the user. */
export type Refund = {
  __typename?: 'Refund'
  /**
   * The date and time the refund information was created.
   * (createAt)
   */
  createdAt: Scalars['DateTime']
  /** The refund amount. */
  duties?: Maybe<Scalars['Float']>
  /** The ID of the ordered product that was eligible for a refund. */
  lineItemIds?: Maybe<Array<Maybe<Scalars['ID']>>>
  /** The remarks */
  note?: Maybe<Scalars['String']>
  /** the refund status. */
  status?: Maybe<Scalars['String']>
  /**
   * The refunded amount without tax.
   * (subTotalRefunded)
   */
  subTotalRefunded?: Maybe<Scalars['Float']>
  /** The tax of the sub total refund. */
  tax?: Maybe<Scalars['Float']>
  /**
   * The total amount refunded.
   * (totalRefunded)
   */
  totalRefunded?: Maybe<Scalars['Float']>
  /**
   * The date and time the refund information was created.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']
}

/** Information about the customer representing the group. */
export type Representative = {
  __typename?: 'Representative'
  /** The customer's email address. */
  email?: Maybe<Scalars['String']>
  /** Name of the customer representing the group. */
  name?: Maybe<Scalars['String']>
  /** The customer's phone number. */
  phone?: Maybe<Scalars['String']>
}

/** Represents information about the options that make up a product variation. */
export type SelectedOption = Node & {
  __typename?: 'SelectedOption'
  /** The ID of the object. */
  id: Scalars['ID']
  /** Represents the product options name selected in that variation. */
  name: I18nString
  /** Represents the product options value selected in that variation. */
  value: I18nString
}

/** Sort the data to be acquired by specifying the field and sort format. */
export type SortInput = {
  /**
   * The field on which the sort is based.
   * When targeting child fields, add "__" to the end of the parent field to concatenate.
   */
  field: Scalars['String']
  /** Sort format (ascending or descending). */
  type: SortType
}

/** The sort type of the query. */
export enum SortType {
  /** Ascending */
  Asc = 'ASC',
  /** Descending */
  Desc = 'DESC',
}

/** 単位コード */
export enum UnitCode {
  /** 日 */
  PerDay = 'PER_DAY',
  /** 時間 */
  PerHour = 'PER_HOUR',
}

/** Indicates information related to incidental information. */
export type UserMetaData = {
  __typename?: 'UserMetaData'
  /**
   * The reference value for regular recovery.
   * (defaultLimit)
   */
  defaultLimit: Scalars['Int']
  /** The discount rate. */
  discount: Scalars['Float']
  /**
   * The date and time granted.
   * (grantedAt)
   */
  grantedAt: Scalars['DateTime']
  /** The remaining number of discounts available. */
  limit: Scalars['Int']
  /**
   * The whether you can make a reservation for free time.
   * (timeFree)
   */
  timeFree?: Maybe<Scalars['Boolean']>
}

export type OrderFragment = {
  __typename?: 'Order'
  approval: OrderApproval
  approvalRequired: boolean
  id: string
  numberOfPeople: number
  serialNumber: string
  status: OrderStatus
  subTotalPrice: number
  totalPrice: number
  totalTax: number
  orderNumber: number
  purpose?: OrderPurpose | null
  canceledAt?: any | null
  period?: {
    __typename?: 'Period'
    start?: any | null
    end?: any | null
  } | null
  calendar?: {
    __typename?: 'Calendar'
    approval: boolean
    eventName?: string | null
    organizer?: string | null
    publishableDate?: any | null
  } | null
}

export type LineItemFragment = {
  __typename?: 'OrderLineItem'
  id: string
  name: { __typename?: 'I18nString'; jaJp: string }
  product?: {
    __typename?: 'Product'
    images?: Array<{ __typename?: 'Image'; src: any }> | null
  } | null
}

export type OrdersForObserverQueryVariables = Exact<{ [key: string]: never }>

export type OrdersForObserverQuery = {
  __typename?: 'QueryRoot'
  orders?: {
    __typename?: 'OrderConnection'
    edges: Array<{
      __typename?: 'OrderEdge'
      node?: {
        __typename?: 'Order'
        numberOfPeople: number
        purpose?: OrderPurpose | null
        bookingDates: Array<{ __typename?: 'BookingDate'; date: any }>
        period?: {
          __typename?: 'Period'
          start?: any | null
          end?: any | null
        } | null
        lineItems?: {
          __typename?: 'OrderLineItemConnection'
          edges: Array<{
            __typename?: 'OrderLineItemEdge'
            node?: {
              __typename?: 'OrderLineItem'
              id: string
              colorCode?: string | null
              displayCalendar?: boolean | null
              name: { __typename?: 'I18nString'; jaJp: string }
              variantTitle?: { __typename?: 'I18nString'; jaJp: string } | null
              arenaBookingInfo?: Array<{
                __typename?: 'ArenaBookingInfo'
                dateOfUse: any
                quantity: number
              } | null> | null
            } | null
          } | null>
        } | null
      } | null
    } | null>
  } | null
}

export type BookingStatusOfTheDayQueryVariables = Exact<{
  input?: InputMaybe<BookingStatusOfTheDayInput>
}>

export type BookingStatusOfTheDayQuery = {
  __typename?: 'QueryRoot'
  bookingStatusOfTheDay?: {
    __typename?: 'BookingStatusOfTheDay'
    date?: any | null
    products?: Array<{
      __typename?: 'BookingStatusOfTheDayProducts'
      id: string
      name: string
      variants?: Array<{
        __typename?: 'BookingStatusOfTheDayProductVariants'
        id: string
        name: string
        availableForSale: boolean
        bookings: Array<string>
      }> | null
    }> | null
  } | null
}

export type BookingStatusOfTheMonthQueryVariables = Exact<{
  date?: InputMaybe<Scalars['Date']>
}>

export type BookingStatusOfTheMonthQuery = {
  __typename?: 'QueryRoot'
  bookingStatusOfTheMonth?: {
    __typename?: 'BookingStatusOfTheMonth'
    date?: any | null
    products?: Array<{
      __typename?: 'BookingStatusOfTheMonthProducts'
      id: string
      name: string
      variants?: Array<{
        __typename?: 'BookingStatusOfTheMonthProductVariants'
        id: string
        name: string
        availableForSale: boolean
        bookingDates: Array<any | null>
      }> | null
    }> | null
  } | null
}

export type OrderForObserverQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type OrderForObserverQuery = {
  __typename?: 'QueryRoot'
  orderForObserver?: {
    __typename?: 'Order'
    cancellationFee?: number | null
    createdAt: any
    updatedAt: any
    discountPrice?: number | null
    entryFee: boolean
    estimateNumber?: string | null
    originalSubTotalPrice: number
    originalSubTotalPriceTaxExcluded: number
    originalTotalPrice: number
    originalTotalTax: number
    reasonForDisapproval?: string | null
    saleOfGoods: boolean
    status: OrderStatus
    subTotalPrice: number
    subTotalPriceTaxExcluded: number
    specialPriceIncluded: boolean
    totalPrice: number
    totalTax: number
    canceledAt?: any | null
    cancelReason?: OrderCancelReason | null
    approval: OrderApproval
    approvalRequired: boolean
    id: string
    numberOfPeople: number
    serialNumber: string
    orderNumber: number
    purpose?: OrderPurpose | null
    bookingDates: Array<{
      __typename?: 'BookingDate'
      checkedInAt?: any | null
      checkedOutAt?: any | null
      date: any
      exceededTime?: any | null
    }>
    extensionFee?: Array<{
      __typename?: 'ExtensionFee'
      reason: string
      value: number
    } | null> | null
    discountFee?: {
      __typename?: 'DiscountFee'
      value: number
      reason: string
    } | null
    lineItems?: {
      __typename?: 'OrderLineItemConnection'
      edges: Array<{
        __typename?: 'OrderLineItemEdge'
        lineItem?: {
          __typename?: 'OrderLineItem'
          baseTimeUnit?: number | null
          price: number
          specialPrice: number
          timeBased: boolean
          quantity: number
          variant?: string | null
          unit?: string | null
          id: string
          variantTitle?: { __typename?: 'I18nString'; jaJp: string } | null
          arenaBookingInfo?: Array<{
            __typename?: 'ArenaBookingInfo'
            dateOfUse: any
            quantity: number
            id: string
          } | null> | null
          product?: {
            __typename?: 'Product'
            id: string
            approvalRequired: boolean
            adminOnlyReservation: boolean
            createdAt: any
            status: ProductStatus
            timeBased: boolean
            updatedAt: any
            name: { __typename?: 'I18nString'; jaJp: string }
            images?: Array<{
              __typename?: 'Image'
              id: string
              src: any
              filename: string
              key: string
              mimeType: string
            }> | null
          } | null
          name: { __typename?: 'I18nString'; jaJp: string }
        } | null
      } | null>
    } | null
    modifierInfo?: {
      __typename?: 'OrderModifierConnection'
      totalCount: number
      pageInfo: {
        __typename?: 'PageInfo'
        hasNextPage: boolean
        hasPreviousPage: boolean
      }
      edges: Array<{
        __typename?: 'OrderModifierEdge'
        cursor: string
        modify?: {
          __typename?: 'OrderModifier'
          reason: string
          modifiedAt: any
          modifier?: {
            __typename?: 'Member'
            id: string
            auth0Id?: string | null
            avatarUrl?: string | null
            createdAt: any
            email: string
            firstName: string
            lastName: string
            isActive: boolean
            updatedAt: any
          } | null
        } | null
      } | null>
    } | null
    payment?: {
      __typename?: 'Payment'
      amount?: number | null
      errorMessage?: string | null
      processedAt?: any | null
      refundablePeriod?: any | null
      status: PaymentStatus
      updatedAt: any
    } | null
    period?: {
      __typename?: 'Period'
      start?: any | null
      end?: any | null
    } | null
    rate?: {
      __typename?: 'RateInfo'
      variantId: string
      title?: { __typename?: 'I18nString'; jaJp: string } | null
    } | null
    refund?: {
      __typename?: 'Refund'
      createdAt: any
      duties?: number | null
      lineItemIds?: Array<string | null> | null
      note?: string | null
      status?: string | null
      subTotalRefunded?: number | null
      tax?: number | null
      totalRefunded?: number | null
      updatedAt: any
    } | null
    calendar?: {
      __typename?: 'Calendar'
      approval: boolean
      eventName?: string | null
      organizer?: string | null
      publishableDate?: any | null
    } | null
  } | null
}

export const OrderFragmentDoc = gql`
  fragment order on Order {
    approval
    approvalRequired
    id
    period {
      start
      end
    }
    calendar {
      approval
      eventName
      organizer
      publishableDate
    }
    numberOfPeople
    serialNumber
    status
    subTotalPrice
    totalPrice
    totalTax
    orderNumber
    purpose
    canceledAt
  }
`
export const LineItemFragmentDoc = gql`
  fragment lineItem on OrderLineItem {
    id
    name {
      jaJp
    }
    product {
      images {
        src
      }
    }
  }
`
export const OrdersForObserverDocument = gql`
  query OrdersForObserver {
    orders(displayCalendar: true) {
      edges {
        node {
          numberOfPeople
          purpose
          bookingDates {
            date
          }
          period {
            start
            end
          }
          lineItems {
            edges {
              node {
                id
                name {
                  jaJp
                }
                variantTitle {
                  jaJp
                }
                colorCode
                displayCalendar
                arenaBookingInfo {
                  dateOfUse
                  quantity
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useOrdersForObserverQuery__
 *
 * To run a query within a React component, call `useOrdersForObserverQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersForObserverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersForObserverQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrdersForObserverQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OrdersForObserverQuery,
    OrdersForObserverQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OrdersForObserverQuery,
    OrdersForObserverQueryVariables
  >(OrdersForObserverDocument, options)
}
export function useOrdersForObserverLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrdersForObserverQuery,
    OrdersForObserverQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OrdersForObserverQuery,
    OrdersForObserverQueryVariables
  >(OrdersForObserverDocument, options)
}
export type OrdersForObserverQueryHookResult = ReturnType<
  typeof useOrdersForObserverQuery
>
export type OrdersForObserverLazyQueryHookResult = ReturnType<
  typeof useOrdersForObserverLazyQuery
>
export type OrdersForObserverQueryResult = Apollo.QueryResult<
  OrdersForObserverQuery,
  OrdersForObserverQueryVariables
>
export const BookingStatusOfTheDayDocument = gql`
  query BookingStatusOfTheDay($input: BookingStatusOfTheDayInput) {
    bookingStatusOfTheDay(input: $input) {
      date
      products {
        id
        name
        variants {
          id
          name
          availableForSale
          bookings
        }
      }
    }
  }
`

/**
 * __useBookingStatusOfTheDayQuery__
 *
 * To run a query within a React component, call `useBookingStatusOfTheDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingStatusOfTheDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingStatusOfTheDayQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookingStatusOfTheDayQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingStatusOfTheDayQuery,
    BookingStatusOfTheDayQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BookingStatusOfTheDayQuery,
    BookingStatusOfTheDayQueryVariables
  >(BookingStatusOfTheDayDocument, options)
}
export function useBookingStatusOfTheDayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingStatusOfTheDayQuery,
    BookingStatusOfTheDayQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BookingStatusOfTheDayQuery,
    BookingStatusOfTheDayQueryVariables
  >(BookingStatusOfTheDayDocument, options)
}
export type BookingStatusOfTheDayQueryHookResult = ReturnType<
  typeof useBookingStatusOfTheDayQuery
>
export type BookingStatusOfTheDayLazyQueryHookResult = ReturnType<
  typeof useBookingStatusOfTheDayLazyQuery
>
export type BookingStatusOfTheDayQueryResult = Apollo.QueryResult<
  BookingStatusOfTheDayQuery,
  BookingStatusOfTheDayQueryVariables
>
export const BookingStatusOfTheMonthDocument = gql`
  query BookingStatusOfTheMonth($date: Date) {
    bookingStatusOfTheMonth(date: $date) {
      date
      products {
        id
        name
        variants {
          id
          name
          availableForSale
          bookingDates
        }
      }
    }
  }
`

/**
 * __useBookingStatusOfTheMonthQuery__
 *
 * To run a query within a React component, call `useBookingStatusOfTheMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingStatusOfTheMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingStatusOfTheMonthQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useBookingStatusOfTheMonthQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingStatusOfTheMonthQuery,
    BookingStatusOfTheMonthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BookingStatusOfTheMonthQuery,
    BookingStatusOfTheMonthQueryVariables
  >(BookingStatusOfTheMonthDocument, options)
}
export function useBookingStatusOfTheMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingStatusOfTheMonthQuery,
    BookingStatusOfTheMonthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BookingStatusOfTheMonthQuery,
    BookingStatusOfTheMonthQueryVariables
  >(BookingStatusOfTheMonthDocument, options)
}
export type BookingStatusOfTheMonthQueryHookResult = ReturnType<
  typeof useBookingStatusOfTheMonthQuery
>
export type BookingStatusOfTheMonthLazyQueryHookResult = ReturnType<
  typeof useBookingStatusOfTheMonthLazyQuery
>
export type BookingStatusOfTheMonthQueryResult = Apollo.QueryResult<
  BookingStatusOfTheMonthQuery,
  BookingStatusOfTheMonthQueryVariables
>
export const OrderForObserverDocument = gql`
  query orderForObserver($id: ID!) {
    orderForObserver(id: $id) {
      ...order
      bookingDates {
        checkedInAt
        checkedOutAt
        date
        exceededTime
      }
      cancellationFee
      createdAt
      updatedAt
      discountPrice
      entryFee
      extensionFee {
        reason
        value
      }
      discountFee {
        value
        reason
      }
      estimateNumber
      lineItems {
        edges {
          lineItem: node {
            ...lineItem
            baseTimeUnit
            price
            specialPrice
            timeBased
            quantity
            variant
            variantTitle {
              jaJp
            }
            unit
            arenaBookingInfo {
              dateOfUse
              quantity
              id
            }
            product {
              id
              approvalRequired
              adminOnlyReservation
              createdAt
              name {
                jaJp
              }
              status
              timeBased
              updatedAt
              images {
                id
                src
                filename
                key
                mimeType
              }
            }
          }
        }
      }
      modifierInfo {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        edges {
          modify: node {
            modifier {
              id
              auth0Id
              avatarUrl
              createdAt
              email
              firstName
              lastName
              isActive
              updatedAt
            }
            reason
            modifiedAt
          }
          cursor
        }
      }
      originalSubTotalPrice
      originalSubTotalPriceTaxExcluded
      originalTotalPrice
      originalTotalTax
      payment {
        amount
        errorMessage
        processedAt
        refundablePeriod
        status
        updatedAt
        processedAt
      }
      period {
        start
        end
      }
      rate {
        variantId
        title {
          jaJp
        }
      }
      reasonForDisapproval
      refund {
        createdAt
        duties
        lineItemIds
        note
        status
        subTotalRefunded
        tax
        totalRefunded
        updatedAt
      }
      saleOfGoods
      status
      subTotalPrice
      subTotalPriceTaxExcluded
      specialPriceIncluded
      totalPrice
      totalTax
      canceledAt
      cancelReason
    }
  }
  ${OrderFragmentDoc}
  ${LineItemFragmentDoc}
`

/**
 * __useOrderForObserverQuery__
 *
 * To run a query within a React component, call `useOrderForObserverQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderForObserverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderForObserverQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderForObserverQuery(
  baseOptions: Apollo.QueryHookOptions<
    OrderForObserverQuery,
    OrderForObserverQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrderForObserverQuery, OrderForObserverQueryVariables>(
    OrderForObserverDocument,
    options
  )
}
export function useOrderForObserverLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrderForObserverQuery,
    OrderForObserverQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OrderForObserverQuery,
    OrderForObserverQueryVariables
  >(OrderForObserverDocument, options)
}
export type OrderForObserverQueryHookResult = ReturnType<
  typeof useOrderForObserverQuery
>
export type OrderForObserverLazyQueryHookResult = ReturnType<
  typeof useOrderForObserverLazyQuery
>
export type OrderForObserverQueryResult = Apollo.QueryResult<
  OrderForObserverQuery,
  OrderForObserverQueryVariables
>
